"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoyaltyDialog = void 0;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var ShowLoyaltyDialog = _interopRequireWildcard(require("@ori-events/show-loyalty-dialog"));
var _react = require("react");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useLoyaltyDialog = () => {
  const [data, setData] = (0, _react.useState)();
  const handleLoyaltyDialogResult = (0, _react.useCallback)(result => {
    if (data) {
      const event = new CustomEvent(LoyaltyDialogResult.Name, {
        detail: {
          ...data,
          result
        }
      });
      window.dispatchEvent(event);
      // unmountDialog
      setData(undefined);
    }
  }, [data]);
  const handleClose = (0, _react.useCallback)(() => handleLoyaltyDialogResult(LoyaltyDialogResult.LoyaltyDialogResults.CLOSE), [handleLoyaltyDialogResult]);
  const handleBuyForPoints = (0, _react.useCallback)(() => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_POINTS), [handleLoyaltyDialogResult]);
  const handleBuyForMoney = (0, _react.useCallback)(() => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_MONEY), [handleLoyaltyDialogResult]);
  (0, _react.useEffect)(() => {
    const showLoyaltyDialogCallback = event => {
      setData(event.detail);
    };
    window.addEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);
    return () => window.removeEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);
  }, []);
  return {
    data,
    handleBuyForMoney,
    handleBuyForPoints,
    handleClose
  };
};
exports.useLoyaltyDialog = useLoyaltyDialog;
